import { createApp, onCaughtError } from './App'
import { createRoot } from 'react-dom/client'
import { createElement } from 'react'
import { resetQueryClient } from './queryClient'
import { appStore } from './appStore'
import { registerServiceWorker } from './lib/installPwa'
import './styles/index.css'

appStore.set(resetQueryClient)

const App = createApp(appStore)
createRoot(document.getElementById('bundler-root')!, { onCaughtError }).render(
  createElement(App),
)

registerServiceWorker()

